import { cn } from "../../lib/utils";

const COLORS = {
  info:    "bg-brand-50 text-brand-800 border-brand-300",
  success: "bg-emerald-50 text-emerald-800 border-emerald-300",
  error:   "bg-red-50 text-red-800 border-red-300",
  warning: "bg-amber-50 text-amber-800 border-amber-300",
};

export function Alert({ children, type = "info", className }) {
  return (
    <div
      className={cn(
        "border-l-4 px-4 py-3 rounded-lg text-sm",
        COLORS[type] || COLORS.info,
        className
      )}
    >
      {children}
    </div>
  );
}

export function AlertDescription({ children, className }) {
  return <p className={cn("text-sm mt-1", className)}>{children}</p>;
}
